export default __webpack_public_path__ + "static/media/main-logo-tr.1f0be717.png";